<template>
    <main class="trips-list-wrapper sorted-filtered-list">
        <div class="list-banner">
            <div class="overlay"></div>
            <h1 class="banner-title">Trips</h1>
        </div>
        <LoadingScreen v-if="!loaded" message="Loading your trips…" />
        <div v-else-if="!isEmpty || hasQuery" class="max-width-container">
            <div class="action-bar">
                <router-link to="/trips/add">
                    <Bttn icon="add_circle" class="add-trip">Add new trip</Bttn>
                </router-link>
                <ListActions :current="actionsEdit" @update="setAction" />
            </div>
            <div
                :class="[
                    'sort-filter-bar',
                    { 'with-margin': loaded && actionsEdit },
                ]"
            >
                <FilteringWidget
                    v-if="loaded"
                    :editing="actionsEdit"
                    :filters="filters"
                    :query="store.query"
                    @update="updateList"
                />
                <SortingWidget
                    v-if="loaded"
                    :editing="actionsEdit"
                    :columns="sortColumns"
                    :query="store.query"
                    @update="updateList"
                />
            </div>
            <div v-if="loaded" id="trips-list">
                <ul>
                    <TripCardItem
                        v-for="item in list"
                        :key="item.id"
                        :item="item"
                    />
                </ul>
            </div>
        </div>
        <div v-else class="max-width-container empty">
            <router-link to="/trips/add">
                <Bttn icon="add_circle" class="add-trip">Add new trip</Bttn>
            </router-link>
        </div>
    </main>
</template>

<script>
import { useTripStore } from "js/stores/tripStore";
import TripCardItem from "js/components/list-items/TripCardItem";
import ListActions from "js/components/widgets/ListActions";
import LoadingScreen from "js/components/common/LoadingScreen";
import SortedFilteredListPage from "js/base/SortedFilteredListPage";

export default {
    name: "TripList",
    components: {
        TripCardItem,
        LoadingScreen,
        ListActions,
    },
    extends: SortedFilteredListPage,
    data() {
        return {
            loaded: false,
            sortColumns: [
                ["start_date", "Date"],
                ["name", "Name"],
                ["duration", "Duration"],
            ],
            filters: [
                ["reason", "Travel reason", this.$enumOptions("travel_reason")],
                ["mot", "Transportation", this.$enumOptions("transport")],
            ],
        };
    },
    async mounted() {
        this.store = useTripStore();
        this.list = this.store.dirty ? await this.getList() : this.store.list;
        await this.getDynamicFilters();
        this.loaded = true;
    },
    methods: {
        async getList() {
            const tripList = await this.store.fetch(
                "/api/trips?with-locations",
                this.store.query
            );
            this.store.populate(tripList);

            return this.store.list;
        },
        async getDynamicFilters() {
            const companions = await this.store.fetch("api/utils/companions");
            this.filters.push([
                "companion",
                "Companion",
                companions.map((companion) => [companion.id, companion.name]),
            ]);
        },
    },
};
</script>
